// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-sticky[data-v-16a2806b]{position:relative!important}}@media only screen and (min-width:1295px){.mr-custom[data-v-16a2806b]{margin-right:4rem!important}}@media only screen and (min-width:1350px){.mr-custom[data-v-16a2806b]{margin-right:2rem!important}}@media only screen and (min-width:1430px){.mr-custom[data-v-16a2806b]{margin-right:0!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
